import React from 'react';
import { Link, useLocation } from 'react-router-dom';

function NavBar() {
    const location = useLocation();
    
    const getLinkClass = (path) => {
        const isActive = location.pathname === path;
        const baseClass = "transition-colors duration-200 text-sm font-medium";
        return isActive
            ? `${baseClass} text-primary font-bold border-b-2 border-primary`
            : `${baseClass} text-zinc-600 hover:text-primary`;
    };

    return (
        <header className="sticky top-0 w-full h-[64px] bg-base-100/80 backdrop-blur-md border-b border-zinc-200 z-10">
            <div className="flex justify-between items-center px-6 md:px-12 max-w-7xl mx-auto h-full">
                <Link
                    to="/"
                    className="text-2xl font-bold tracking-tighter text-base-content hover:text-primary transition-colors"
                >
                    Guardhart Security
                </Link>

                <nav className="hidden md:flex items-center gap-8">
                    <Link to="/" className={getLinkClass('/')}>Home</Link>
                    <Link to="/about" className={getLinkClass('/about')}>About</Link>
                    <Link to="/services" className={getLinkClass('/services')}>Services</Link>
                    <Link to="/blog" className={getLinkClass('/blog')}>Blog</Link>
                    <Link to="/careers" className={getLinkClass('/careers')}>Careers</Link>
                    <Link to="/contact" className={getLinkClass('/contact')}>Contact</Link>
                </nav>

                <div className="flex items-center gap-4">
                    <Link
                        to="/contact"
                        className="hidden md:block bg-primary text-primary-content px-6 py-2 uppercase tracking-widest text-[11px] font-bold rounded active:scale-95 transition-all hover:brightness-110"
                    >
                        Get a Quote
                    </Link>

                    <label htmlFor="nav-drawer" className="btn btn-ghost btn-circle">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-6 w-6 text-base-content"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h7" />
                        </svg>
                    </label>
                </div>
            </div>
        </header>
    );
}

export default NavBar;